import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.dateRangePicker.background};
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: ${ColorPalette.HEX.White};
  z-index: 2;
`;

export const Calendar = styled.section`
  overflow-y: auto;
  flex: 1;
  padding-bottom: 100px;
`;

export const Month = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 32px;
  background-color: ${({ theme }) => theme.secondaryBackgroundColor};
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.secondaryColor};
`;

export const NextIcon = styled(IoIosArrowForward)`
  font-size: 25px;
`;

export const PreviousIcon = styled(IoIosArrowBack)`
  margin-left: auto;
  font-size: 25px;
`;

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px;
`;

export const ConfirmButton: any = styled(Button)`
  height: 56px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  border-width: 0;
`;

export const TripDates: any = styled.div`
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.primaryBackgroundColor};
`;

TripDates.Departure = styled.div`
  width: 100%;
  text-align: left;
  overflow: hidden;
  padding: 12px 16px;
  border-radius: 10px;
  cursor: pointer;

  &.active {
    border: 1px solid ${({ theme }) => theme.primaryBackgroundColor};
  }
`;

TripDates.Arrival = TripDates.Departure;

TripDates.Label = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;
